import { useState } from "react";
import { Button, Form, ProgressBar } from "react-bootstrap";
import { db, storage } from "../FirebaseConfig";
import firebase from 'firebase';

const AddProduct = () => {
    const [productname, setProductname] = useState('');
    //const [productdesc, setProductdesc] = useState('');
    const [productprice, setProductprice] = useState('');
    const [productimage, setProductimage] = useState(null);
    const [progress, setProgress] = useState(0);

    const handleChange = e => {
        if (e.target.files[0]){
            setProductimage(e.target.files[0]);
        }
    }

    const handleUpload = () => {
        const uploadTask = storage.ref(`productImages/${productimage.name}`).put(productimage);
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                //progress
                const progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) *100
                );
                setProgress(progress);
            },
            (error) => {
                console.log(error);
                alert(error.message);
            },
            () => {
                //complete fn
                storage.ref('productImages').child(productimage.name).getDownloadURL()
                .then(url => {
                    //post img in db
                    db.collection('PRODUCTS').add({
                        timestamp : firebase.firestore.FieldValue.serverTimestamp(),
                        /*product_desc : productdesc,*/
                        product_name : productname,
                        product_price : productprice,
                        product_image : url
                    });
                    setProgress(0);
                    setProductprice('');
                    //setProductdesc('');
                    setProductname('');
                    setProductimage(null);
                    alert('Product added');
                });
                
            }
        );
    }


    return(
        <div className = 'admin'>
            <h4>Add Items</h4>
            <Form className = 'adminForm'>
                <ProgressBar animated now={progress} className = 'adminProgress'/>

                <Form.Group controlId = 'formBasicName'>
                    <Form.Label>Product Name</Form.Label>
                    <Form.Control type = 'text' onChange = {e => setProductname(e.target.value)}/>
                </Form.Group>

                {/*<Form.Group controlId = 'formBasicDesc'>
                    <Form.Label>Product Description</Form.Label>
                    <Form.Control as = 'textarea' rows = {3} onChange = {e => setProductdesc(e.target.value)}/>
                </Form.Group>*/}

                <Form.Group controlId = 'formBasicPrice'>
                    <Form.Label>Product Price</Form.Label>
                    <Form.Control type = 'text' onChange = {e => setProductprice(e.target.value)}/>
                </Form.Group>

                <Form.Group>
                    <Form.File id="imageInput" label="Upload Product Image" onChange = {handleChange} />
                </Form.Group>
                
                <Button variant = 'dark' onClick = {handleUpload}>
                    Submit
                </Button>
            </Form>
        </div>
    );
}

export default AddProduct;